<template>
  <div :class="[[...classList],['flex']]">
    <label v-show="label" class="label">
      <span v-if="required" class="col-red">*</span>
      {{ label }}
    </label>
    <el-select
		 :value="value" 
		 :placeholder="placeholder?placeholder:placeholder+label"
		 :filterable="filterable"
     :disabled="disabled"
     :multiple="multiple"
     :style="selectStyle"
		 @change="changHandle">
      <el-option
        v-for="(v,i) in options"
        :key="v.value||v.title||i"
        :label="v.label||v.title"
        :value="v.value||v.title"
      >
      <span v-if="html" style="float: left" v-html="v.label||v.name||v.title"></span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
export default {
  name: "selectBox",
  props: {
    required:{
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number, Array],
      default: "",
    },
    placeholder: {
      type: String,
      default: `请选择`,
    },
		filterable:{
			type:[Boolean, String],
			default:false
		},
    options: {
      type: Array,
      default: ()=>{
				return [];
			},
    },
    classList:{
      type:[Array,String]
    },
    html:{
      type:Boolean,
      default:false
    },
    disabled:{
      type:[String,Boolean],
      default: false
    },
    multiple:{
      type: Boolean,
      default: false
    },
    selectStyle:{
      type:[String, Object],
      default:''
    }
  },
	methods:{
		changHandle(v){
			this.$emit('input',v);
      this.$emit('change',v)
		}
	},
  components: {
    elSelect: Select,
    elOption: Option,
  },
};
</script>
<style scoped>
.label {
  min-width: 85px;
  text-align: right;
  /* display: inline-block; */
  padding: 0 10px;
  line-height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/selectBox.vue